module.exports = __webpack_public_path__ + "static/media/storeFrontDark.f52b89f6.svg";